import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { z } from 'zod';

const SalesRankingLastUpdatedAtResponseSchema = z.object({
  lastUpdatedAt: z.string().describe('판매 상품 랭킹 데이터 최종 갱신 시각'),
});

export type GetSalesRankingLastUpdatedAtResponse = MusinsaStandardResponse<
  z.infer<typeof SalesRankingLastUpdatedAtResponseSchema>
>;
